import { useChatTypingStore } from '#modules/chat/model/chatTypingStore';

/**
 * Кадр «печатает» из WS.
 *
 * Событие приходит и на начало печати, и на её конец — теперь они различаются флагом `typing`
 * в полезной нагрузке (teamplay-comment, миграция 125). Раньше флага не было, оба кадра
 * выглядели одинаково, и «печатает…» гасло только по трёхсекундному таймауту: собеседник давно
 * увёл курсор, а надпись держалась.
 *
 * Значение приезжает строкой: шлюз уведомлений кладёт в `params` весь payload через `asText()`.
 * Старый бэкенд флага не шлёт вовсе — там `undefined`, и это по-прежнему «начал печатать»,
 * иначе на не выкаченном окружении индикатор пропал бы совсем.
 */
export const applyWsChatTypingEvent = (chatId: string, userId: string, typing?: unknown) => {
  const stopped = typing === false || typing === 'false';

  if (stopped) {
    useChatTypingStore.getState().clearTyping(chatId);
    return;
  }

  useChatTypingStore.getState().setTyping({ chatId, userId });
};
